(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("logoService", [logoService]);
    function logoService() {
        //review how to bind to this value
        //http://stsc3000.github.io/blog/2013/10/26/a-tale-of-frankenstein-and-binding-to-service-values-in-angular-dot-js/
        var logoServiceFactory = {
            logo: ""
        };
        return logoServiceFactory;
    }
}());
